import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import CheatSheet from './views/CheatSheet.vue'
import Home from './views/Home.vue'
import Page from './views/Page.vue'
import TripDetail from './views/TripDetail.vue'
import TourismOffice from './views/TourismOffice.vue'
import Imprint from './views/Imprint.vue'
import Privacy from './views/Privacy.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'home' }
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '/cheat-sheet',
      name: 'cheatsheet',
      component: CheatSheet
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/trip/:uid',
      name: 'tripdetail',
      component: TripDetail,
      props: true
    },
    {
      path: '/page/:uid',
      name: 'page',
      component: Page
    },
    {
      path: '/tourism-office',
      name: 'tourism-office',
      component: TourismOffice
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: Imprint
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }  
})
